<template>
    <div :class="classBox">
        <slot name="title"></slot>

        <slot name="details">
            <div class="media mb-3">
                <img class="d-flex mr-3 rounded-circle avatar-lg" :src="user.image" alt="Generic placeholder image">
                <div class="media-body">
                    <h4 class="mt-0 mb-1">{{ user.name }}</h4>
                    <p class="text-muted">{{ user.username }} | {{ user.role }}</p>
                    <a :href="`mailto:${user.email}`" class="btn- btn-xs btn-info">Email</a>
                    <a :href="`tel:${user.phone}`" class="btn- btn-xs btn-secondary">Ligar</a>
                </div>
            </div>
        </slot>

        <slot name="header">
            <h5 class="mb-3 mt-4 text-uppercase bg-light p-2">
                <i class="dripicons-align-center mr-1"></i>
                Info
            </h5>
        </slot>
        <slot name="body">
            <h4 class="font-13 text-muted text-uppercase mb-1">INFO :</h4>
            <p class="mb-3">0</p>
        </slot>
    </div>
</template>

<script>
export default {
    name: "UserDetails",
    model: {
        prop: 'baseUser',
        event: 'input',
    },
    props: {
        userId: {
            type: Number,
            required: false,
            coerce: (val) => parseInt(val),
            default: window.userAuth ? window.userAuth.id : 0,
        },
        hasMessageError: {
            type: Boolean,
            required: false,
            default: true
        },
        baseUser: {
            type: Object,
            required: false,
            default: () => ({
                name: 'PVD',
                username: null,
                role: null,
                email: null,
                phone: null,
                image: 'https://placehold.it/160x160/60c7da/ffffff/&text=PVD',
            })
        },
        classBox: {
            type: String,
            default: 'card-box'
        },
    },
    computed: {
        user: {
            get(){
                return Object.assign(this.defaultUser(), this.baseUser);
            },

            set(value){
                this.$emit('input', Object.assign(this.defaultUser(), value))
            }
        }
    },
    watch: {
        userId(newValue){
            this.fetchUser()
        }
    },
    data: () => {
        return {}
    },
    created() {
        // if (this.baseUser) {
        //     this.user = this.baseUser
        // } else {
        //     this.fetchUser()
        // }
    },
    beforeDestroy() {
        this.user = this.defaultUser()
    },
    methods: {
        async fetchUser(){
            if (this.userId === 0) {
                this.user = this.defaultUser()
                return;
            }

            try {
                const { data } = await this.$axios.post(route('api.auth.user.details', this.userId))
                this.user = data
            } catch (e) {
                console.error('ERROR GET USER', e)
                if(this.hasMessageError){
                    toastError('Não foi possível encontrar a informação')
                }
            }
        },
        defaultUser(){
            return {
                name: null,
                username: null,
                role: null,
                email: null,
                phone: null,
                image: 'https://placehold.it/160x160/60c7da/ffffff/&text=PVD',
            }
        },
        updateUser(user) {
          return this.user = user
        }
    }
}
</script>

<style scoped>

</style>
